import { Link } from 'react-router-dom';
import { serviceForPost } from '@/components/services/servicePages';

export default function RelatedServiceBox({ post }) {
  const service = serviceForPost(post);
  return (
    <aside className="mt-10 p-6 rounded-2xl border border-border/50 bg-card">
      <p className="text-xs font-inter font-bold tracking-[0.2em] uppercase text-primary mb-2">Related service</p>
      <Link to={`/services/${service.slug}`} className="text-lg font-inter font-semibold text-foreground hover:text-primary transition-colors">
        {service.h1}
      </Link>
      <p className="text-sm text-muted-foreground font-inter leading-relaxed mt-2 mb-3">{service.meta}</p>
      <Link to="/services" className="text-sm text-primary hover:underline font-inter">
        Explore all our digital services in Dubai & the UAE
      </Link>
    </aside>
  );
}